import MVP from "./components/MVP"
export default MVP
